interface UserVisibleException {
  readonly userVisibleMessage: string;
}

export function isUserVisibleException(exception: unknown): exception is UserVisibleException {
  return (exception as UserVisibleException | undefined)?.userVisibleMessage != null;
}

export function getUserVisibleOrDefaultExceptionMessage(exception: unknown, defaultExceptionMessage: string): string {
  if (isUserVisibleException(exception)) {
    return exception.userVisibleMessage;
  }
  return defaultExceptionMessage;
}
